"use strict";

var React = require("react"),
    PropTypes = require("prop-types"),
    Breadcrumbs = function Breadcrumbs(e) {
  return React.createElement("nav", {
    style: e.style,
    className: "blx-breadcrumbs " + e.className
  }, React.createElement("ul", null, e.breadcrumbs.map(function (e) {
    return React.createElement("li", {
      key: e.text
    }, React.createElement("a", {
      href: e.href,
      title: e.text
    }, e.text));
  })));
};

Breadcrumbs.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string
  }))
}, Breadcrumbs.defaultProps = {
  className: "",
  style: null,
  breadcrumbs: []
}, module.exports = Breadcrumbs;